<h2 mat-dialog-title>{{'signedOut.title'|translate}}</h2>
<mat-dialog-content>
  <p class="draft">{{'signedOut.message'|translate}}</p>
  <mat-dialog-actions>
    <button class="publishPopUpBtn conf-btn" cdkFocusInitial (click)="onReLogin()">{{'button.reLogin'|translate}}</button>
  </mat-dialog-actions>
</mat-dialog-content>
